// @flow
import styled from "styled-components";
import colors from '../../assets/css/colors';

export const TableFlexHeading = styled.div.attrs({
	role: 'row'
})`
	display: flex;
	justify-content: space-between;
	height: ${({ height }) => height || 'auto'};
	background-color: ${colors.nrlDarkGreen};
	align-items: center;
	color: ${({ color }) => color || '#fff'};
	text-transform: uppercase;
	font-size: 10px;
	font-weight: bold;

	> div:first-child {
		padding-left: 20px;
		font-size: 12px;
	}
	.coach {
		background: ${colors.coachPurple};
	}
	${props => props.is_coach && `background: ${colors.coachPurple}`};
`;

export default TableFlexHeading;


// WEBPACK FOOTER //
// ./src/components/Table/TableFlexHeading.js